<template>
  <el-footer class="global-footer">
    <div class="third-box">
      <div class="children-item1">
        <div class="inner-container">
          <!-- 联系我们 -->
          <div class="child-div child-div1 contact-content">
            <h2>{{ t('contactTitle') }}</h2>
            <p>📞 {{ t('phone1') }}</p>
            <p>💬 {{ t('phone2') }}</p>
            <p>📧 cs@drmotor.hk</p>
            <p>📍 {{ t('address') }}</p>
            <!-- 社交媒体图标 -->
            <div class="social-media-icons">
              <a href="https://www.facebook.com/profile.php?id=61577205355724" target="_blank" class="social-icon" title="Facebook">
                <img src="../assets/facebook.png" alt="Facebook" />
              </a>
              <a href="whatsapp://send?phone=+85266860815" target="_blank" class="social-icon" title="WhatsApp">
                <img src="../assets/whatsapp.png" alt="WhatsApp" />
              </a>
              <a href="https://www.instagram.com/dr_moto_ev_hk_ltd/" target="_blank" class="social-icon" title="Instagram">
                <img src="../assets/Instagram.png" alt="Instagram" />
              </a>
            </div>
          </div>
          <!-- 谷歌地图 -->
          <div class="child-div child-div2">
            <!-- 谷歌地图嵌入式iframe -->
            <iframe 
              width="100%" 
              height="100%" 
              frameborder="0" 
              style="border:0"
              loading="lazy"
              allowfullscreen
              aria-hidden="false"
              tabindex="0"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0847162179427!2d114.23822611526445!3d22.311846648358146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400634d6b136f%3A0xc80992f7c9449a12!2sDR%20MOTOR%20LTD!5e0!3m2!1szh-CN!2shk!4v1623456789012" 
            ></iframe>
            <!-- 添加导航按钮 -->
            <a 
              href="https://www.google.com/maps/dir//DR+MOTOR+LTD,+Kwun+Tong+Promenade,+Kwun+Tong,+Hong+Kong" 
              target="_blank" 
              class="navigate-button"
            >
              {{ t('startNavigation') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style scoped>
/* 全局页脚样式 */
.global-footer {
  color: white;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 0;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

/* 第三部分（联系我们和地图）的容器样式 */
.third-box{
  background-image: url("https://www.drmotor.hk/wp-content/uploads/2022/09/278263441_2815800798722942_8535334162049022462_n.jpg");
  height: auto;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  padding: 40px 0;
}

/* 背景遮罩 */
.third-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 1;
}

/* 子项容器 */
.children-item1 {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 0 20px;
}

/* 内部容器 - 并排布局两个子div */
.inner-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 60px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  flex-wrap: nowrap;
}

/* 子div基础样式 - 确保两个容器大小完全一致 */
.child-div {
  width: 500px;
  height: 380px; /* 统一高度 */
  min-height: 380px;
  max-height: 380px;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 3;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.child-div:hover {
  transform: translateY(-5px);
}

/* 联系我们区域样式 */
.child-div1 {
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 380px;
  min-height: 380px;
  max-height: 380px;
  margin: 0;
}

.contact-content {
  padding: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  justify-content: space-between;
}

.contact-content h2 {
  font-size: 28px;
  margin-bottom: 25px;
  color: #ffcc00;
  text-align: left;
  margin-top: 0;
}

.contact-content p {
  font-size: 18px;
  margin-bottom: 12px;
  margin-top: 0;
  color: white;
  text-align: left;
  line-height: 1.6;
}

.contact-content p:last-of-type {
  margin-bottom: 0;
}

/* 社交媒体图标样式 */
.social-media-icons {
  display: flex;
  gap: 15px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  box-sizing: border-box;
}

.social-icon {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 204, 0, 0.1);
  border: 1px solid rgba(255, 204, 0, 0.3);
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.social-icon:hover {
  background-color: rgba(255, 204, 0, 0.3);
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 204, 0, 0.3);
}

.social-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  transition: transform 0.3s ease;
  display: block;
}

/* 地图区域样式 - 添加与联系我们区域相似的透明底框 */
.child-div2 {
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 20px;
  height: 380px;
  min-height: 380px;
  max-height: 380px;
  margin: 0;
}

/* 谷歌地图iframe样式 */
iframe {
  border-radius: 4px;
  transition: opacity 0.3s ease;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* 导航按钮样式 */
.navigate-button {
  position: absolute;
  bottom: 40px;
  right: 40px;
  background-color: #ffcc00;
  color: black;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  z-index: 10;
}

.navigate-button:hover {
  background-color: #ffaa00;
  transform: scale(1.05);
}

/* 响应式设计 - 平板端 */
@media (max-width: 1024px) {
  .inner-container {
    flex-wrap: wrap;
    gap: 40px;
  }
  
  .child-div {
    width: 450px;
    height: 350px;
    min-height: 350px;
    max-height: 350px;
  }
  
  .child-div1,
  .child-div2 {
    height: 350px;
    min-height: 350px;
    max-height: 350px;
  }
  
  .contact-content {
    padding: 30px;
  }
  
  .navigate-button {
    bottom: 30px;
    right: 30px;
  }
  
  .contact-content h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .contact-content p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  
  .social-media-icons {
    padding-top: 15px;
    margin-top: 20px;
  }
  
  .social-icon {
    width: 40px;
    height: 40px;
  }
}

/* 响应式设计 - 手机端 */
@media (max-width: 768px) {
  .inner-container {
    gap: 30px;
  }
  
  .child-div {
    width: 100%;
    max-width: 400px;
    height: 320px;
    min-height: 320px;
    max-height: 320px;
  }
  
  .child-div1,
  .child-div2 {
    height: 320px;
    min-height: 320px;
    max-height: 320px;
  }
  
  .contact-content {
    padding: 25px;
  }
  
  .navigate-button {
    bottom: 25px;
    right: 25px;
  }
  
  .contact-content h2 {
    font-size: 22px;
    margin-bottom: 15px;
  }
  
  .contact-content p {
    font-size: 15px;
  }
  
  .social-media-icons {
    justify-content: center;
  }
}

/* 响应式设计 - 超小屏幕 */
@media (max-width: 480px) {
  .third-box {
    padding: 30px 0;
  }
  
  .children-item1 {
    padding: 0 15px;
  }
  
  .child-div {
    height: 300px;
    min-height: 300px;
    max-height: 300px;
    padding: 15px;
  }
  
  .child-div1,
  .child-div2 {
    height: 300px;
    min-height: 300px;
    max-height: 300px;
  }
  
  .contact-content {
    padding: 20px;
  }
}
</style>
